import React from 'react';
import './Styles.css';
import { RadioButton, RadioButtonInput } from '@ids/react-radio-button';

const CustomRadioButton = ({ label, onChange, checked, id }) => {
  return (
    <RadioButton className="customRadioButton" onClick={onChange}>
      <RadioButtonInput id={id} checked={checked} onChange={() => {}} />
      <label className="radioButton-label">{label}</label>
    </RadioButton>
  );
};

export default CustomRadioButton;
